if (!localStorage.getItem('cc-settings-loaded')) {
  fetch('https://check.cleancanvas.co.uk/', {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    method: 'POST',
    mode: 'cors',
    body: new URLSearchParams({ shop: Shopify.shop, theme: theme.info ? theme.info.name : '' })
  })
    .then((response) => {
      if (response.ok) {
        localStorage.setItem('cc-settings-loaded', 'true');
      }
    });
}

document.addEventListener('shopify:section:load', (evt) => {
  window.initLazyImages();

  // Load and evaluate section specific scripts immediately.
  evt.target.querySelectorAll('script[src]').forEach((script) => {
    const s = document.createElement('script');
    s.src = script.src;
    document.body.appendChild(s);
  });

  // If loaded section is a pop-up, open it.
  if (evt.target.matches('.cc-pop-up')) {
    customElements.whenDefined('pop-up').then(() => {
      evt.target.querySelector('pop-up').open();
    });
  }
});

document.addEventListener('shopify:block:select', (evt) => {
  // If selected block is a slideshow slide, show it and pause autoplay (if enabled).
  if (evt.target.matches('.slideshow__slide')) {
    const slideshow = evt.target.closest('slide-show');

    setTimeout(() => {
      slideshow.setActiveSlide(Number(evt.target.dataset.index));
      slideshow.pauseAutoplay();
    }, 200);
  }

  // If selected block is a slider item, scroll to it.
  if (evt.target.matches('.slider__item')) {
    const carousel = evt.target.closest('carousel-slider');
    if (!carousel.slider) return;

    carousel.slider.scrollTo({
      left: carousel.slides[Array.from(carousel.slides).indexOf(evt.target)].offsetLeft,
      behavior: 'smooth'
    });
  }
});

document.addEventListener('shopify:block:deselect', (evt) => {
  // If deselected block is a slideshow slide, resume autoplay (if enabled).
  if (evt.target.matches('.slideshow__slide')) {
    const slideshow = evt.target.closest('slide-show');

    setTimeout(() => {
      slideshow.resumeAutoplay();
    }, 200);
  }
});

// Debug out custom events
const customEvents = [
  'on:cart:add',
  'on:variant:change',
  'on:line-item:change',
  'on:cart:error',
  'on:cart-drawer:before-open',
  'on:cart-drawer:after-open',
  'on:cart-drawer:after-close',
  'on:quickbuy:before-open',
  'on:quickbuy:after-open',
  'on:quickbuy:after-close',
  'dispatch:cart-drawer:open',
  'dispatch:cart-drawer:refresh',
  'dispatch:cart-drawer:close'
];
customEvents.forEach((event) => {
  document.addEventListener(event, (evt) => {
    if (event.includes('dispatch:cart-drawer') && theme.settings.cartType !== 'drawer') {
      // eslint-disable-next-line
      console.warn(
        'Canopy Theme: The Cart Drawer is not enabled. To enable it, change Theme Settings > Cart > Cart type.'
      );
    } else {
      // eslint-disable-next-line
      console.info(
        '%cTheme event triggered',
        'background: #000; color: #bada55',
        event,
        evt.detail
      );
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
        console.log("✅ Custom variant script loaded!");

        const variantData = window.variantData || [];
        const traySizeDropdown = document.querySelector('custom-select[id^="template"][id*="harvest-right-tray-size"]');

        // Check which secondary dropdown exists
        let secondaryDropdown = document.querySelector('custom-select[id^="template"][id*="divider-set-quantity"]') ||
                                document.querySelector('custom-select[id^="template"][id*="tray-quantity"]');

        if (!traySizeDropdown || !secondaryDropdown || !variantData.length) {
            console.warn("❌ Not a matching product page. Skipping script.");
            return;
        }

        console.log("✅ Tray Size Dropdown Detected:", traySizeDropdown);
        console.log("✅ Secondary Dropdown Detected:", secondaryDropdown);

        function getSelectedTraySize() {
            const traySizeButton = traySizeDropdown.querySelector("button span");
            const traySize = traySizeButton ? traySizeButton.innerText.trim() : null;
            console.log("✅ Selected Tray Size:", traySize);
            return traySize;
        }

        function updateSecondaryOptions() {
            const selectedTraySize = getSelectedTraySize();
            if (!selectedTraySize) {
                console.warn("❌ No Tray Size selected.");
                return;
            }

            // Get valid secondary options based on available variants
            const validOptions = variantData
                .filter(v => v.option1 === selectedTraySize && v.available)
                .map(v => v.option2);

            console.log(`✅ Valid options for ${selectedTraySize}:`, validOptions);

            // Loop through secondary dropdown options and update visibility
            const options = secondaryDropdown.querySelectorAll(".js-option");
            options.forEach(option => {
                const optionValue = option.getAttribute("data-value").trim();
                if (validOptions.includes(optionValue)) {
                    option.style.display = "flex"; // Show valid options
                    option.removeAttribute("disabled");
                } else {
                    option.style.display = "none"; // Hide invalid options
                    option.setAttribute("disabled", "true");
                }
            });

            // Auto-select the first available option
            let firstValidOption = secondaryDropdown.querySelector('.js-option:not([style*="display: none"])');
            if (firstValidOption) {
                firstValidOption.click(); // Simulate a selection
                console.log("✅ Auto-selected:", firstValidOption.getAttribute("data-value"));
            } else {
                console.warn("❌ No valid options available.");
            }
        }

        // Listen for Tray Size changes
        traySizeDropdown.addEventListener("click", function (event) {
            if (event.target.closest(".js-option")) {
                console.log("✅ Tray Size Changed. Updating secondary options...");
                setTimeout(updateSecondaryOptions, 300); // Delay to allow UI update
            }
        });

        // Run the function on page load (for pre-selected variant)
        updateSecondaryOptions();
    }, 1000); // Delay to ensure elements are fully loaded
});

/**
 * ========================================
 * Variant Button Gating – Tray Products
 * Added: 2025-03-31
 * Purpose: Disable Option 2 buttons until Option 1 is selected
 * Author: Katie & ChatGPT 🧠
 * ========================================
 */
document.addEventListener("DOMContentLoaded", function () {
  const option1Buttons = document.querySelectorAll('[data-option-index="0"] input[type="radio"]');
  const option2Buttons = document.querySelectorAll('[data-option-index="1"] input[type="radio"]');

  if (!option1Buttons.length || !option2Buttons.length) return;

  // Initially disable all Option 2 buttons
  option2Buttons.forEach(btn => {
    btn.disabled = true;
    btn.closest('label').style.opacity = 0.5;
    btn.closest('label').style.pointerEvents = 'none';
  });

  // Enable Option 2 once Option 1 is selected
  option1Buttons.forEach(btn => {
    btn.addEventListener("change", () => {
      option2Buttons.forEach(option2 => {
        option2.disabled = false;
        option2.closest('label').style.opacity = 1;
        option2.closest('label').style.pointerEvents = 'auto';
      });

      // Deselect any Option 2 button on load
option2Buttons.forEach(btn => {
  btn.checked = false;
});

    });
  });
});
